import { render, staticRenderFns } from "./ChatAddressBook.vue?vue&type=template&id=11c1435a&scoped=true"
import script from "./ChatAddressBook.vue?vue&type=script&lang=js"
export * from "./ChatAddressBook.vue?vue&type=script&lang=js"
import style0 from "./ChatAddressBook.vue?vue&type=style&index=0&id=11c1435a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c1435a",
  null
  
)

export default component.exports